import { IPaperPlanMapping } from 'src/types/IPPRPlanMappings';

export const initialAddPaperPlanMappingState: IPaperPlanMapping = {
    paperPlanMappingId: '',
    paperPlanId: '',
    paperPlanName: '',
    basePlanName: '',
    basePlanPromoId: '',
    territoryIds: [],
    startDate: '',
    endDate: '',
    description: ''
};
